<template>
  <div>
    <note v-on:delete-note="deleteNote" v-for="note in notes" :note.sync="note" :key="note.id"></note>
  </div>
</template>

<script>
	
	
import sweetalert from 'sweetalert';
import Note from '@/components/Notes/Note';
export default {
  props: ['notes'],
  components: {
    Note,
  },
  methods: {
    deleteNote(note) {	    
		sweetalert({
		  title: "Weg mit dem Dreck?",
		  text: "Die Notiz kann nicht wieder hergestellt werden!",
		  icon: "warning",
		  buttons: {
			  cancel: {
			    text: "Nein",
			    value: null,
			    visible: true,
			    className: "",
			    closeModal: true,
			  },
			  confirm: {
			    text: "Ja, löschen!",
			    value: true,
			    visible: true,
			    className: "",
			    closeModal: true
			  }
			},
		  dangerMode: true,
		})
		.then((willDelete) => {
		  if (willDelete) {
		      const noteIndex = this.notes.indexOf(note);
		      this.$socket.emit('syncNotes', { action: "delete",  data: { id: note.id } } );
		      this.notes.splice(noteIndex, 1);
		  }
		});	    
    },
  },
};
</script>

<style scoped>
p.tasks {
  text-align: center;
}
</style>